import React from 'react';
import { Tabs } from 'antd';
import { withTranslation } from "react-i18next"
import './index.css'
import login from '../../assets/img/login.png'
import LoginFormByUser from './loginUserForm'
import LoginPhoneForm from './loginPhoneForm';
import sanyLogo from '../../assets/img/sany-logo.png'

class Login extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            publicKey:'',
            captchaKey:'',
            phoneCaptchaKey:'',
            phone:'',
        }
    }

    items = [
        {
            key: '1',
            label: this.props.t('passwordLogin', { defaultValue: '密码登录' }),
            children: <LoginFormByUser {...this.props} />,
        },
        {
            key: '2',
            label: this.props.t('captchaLogin', { defaultValue: '验证码登录' }),
            children: <LoginPhoneForm {...this.props} />,
        },
    ];
    

    onChange = (e) =>{
        console.log(e);
    }

    render() {
        const { data } = this.props;
        console.log('data:',data);
        return (
            <div className="login-container login-layout">
                <div className='login-body'>
                    <div className='login-bottom'>
                        <img className='login-img'src={login} alt='' />
                        <div className="footer">
                            {this.props.t('copyRight', { defaultValue:'@三一集团有限公司 版权所有 | 湘ICP备10005672号-14'})}
                        </div>
                    </div>
                    <div className="login-con">
                        <div className='login-front-span'>
                            <div className="logo" style={{ marginBottom: 46 }}>
                                <img src={sanyLogo} alt='' />
                            </div>
                            <p style={{ fontSize: 34, paddingBottom: 14 }}>
                                <span style={{ letterSpacing: 2 }}>
                                    Hi,
                                </span>
                                <span style={{ letterSpacing: 4 }} >
                                    你好！
                                </span>
                            </p>
                            <p style={{ fontSize: 34, paddingBottom: 20 }}>
                                <span style={{ letterSpacing: 4 }}>
                                    欢迎使用三一物流平台（
                                </span>
                                <span style={{ letterSpacing: 2 }}>
                                    iTMS
                                </span>
                                <span>
                                    ）
                                </span>
                            </p>
                            <span style={{ fontSize: 24}}>
                                Welcome to Sany Logistics Platform（iTMS）
                            </span>
                        </div>
                        <div className='login-antd-tab'>
                            <Tabs defaultActiveKey="1" items={this.items} onChange={this.onChange} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Login = withTranslation()(Login);